module.exports = __webpack_public_path__ + "static/media/icon.77032e1c.png";